import { z } from 'zod';

import {
  hoursSchema,
  isoDateSchema,
  isoTimestampSchema,
  uuidSchema,
} from './primitives.js';

export const timeEntrySchema = z.object({
  id: uuidSchema,
  ticketId: uuidSchema.nullable(),
  contractId: uuidSchema,
  harvestEntryId: z.string().min(1),
  userName: z.string().min(1),
  taskName: z.string().min(1),
  hours: hoursSchema,
  notes: z.string(),
  spentDate: isoDateSchema,
  syncedAt: isoTimestampSchema,
});

/**
 * Manual log-time input from the staff UI. The `T-####` tag is added
 * to the note before pushing to Harvest — see SPEC.md §15 Q5.
 */
export const logTimeInputSchema = z.object({
  ticketId: uuidSchema,
  hours: hoursSchema.positive(),
  spentDate: isoDateSchema,
  notes: z.string(),
});

/**
 * Edit a time-entry note during report review. Writes back to Harvest.
 */
export const editTimeEntryNotesInputSchema = z.object({
  notes: z.string(),
});
